import styled from "styled-components/macro";

import { useSettings } from "contexts/SettingsManager/SettingsManager";
import { HOVER_UNDERLINE_CSS } from "components/Dashboard/range-selectors/steppable-range-selectors/ShiftSelector/ShiftSelectorStyles";
import { Z_INDEX } from "constants/constants";
import { goToDay } from "providers/GlobalStateProvider";
import { useDispatch } from "react-redux";
import {
  FULL_DAY_TITLE,
  getToday,
} from "components/Dashboard/range-selectors/steppable-range-selectors/ShiftSelector/shiftUtils";
import { useFormatZoned } from "utils/customHooks/genericHooks";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import { darkModeTextColor } from "constants/colors";
import { useIsDarkMode } from "store/atoms";
import { useTimeZoneMsOffset } from "utils/timeZoneHooks";
const BtnToggleTilesFullDayStyles = styled.div<{ $isDarkMode: boolean }>`
  position: absolute;
  right: 16px;
  bottom: 16px;
  display: flex;
  align-items: center;
  z-index: ${Z_INDEX.L1};
  flex-direction: row;
  .btnToggleFullDay {
    ${HOVER_UNDERLINE_CSS}
    position: relative;
    transition: all 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
    &:last-child {
      margin-top: unset;
      margin-left: 10px;
    }
    &.active {
      color: ${({ $isDarkMode }) =>
        $isDarkMode ? darkModeTextColor : "black"};
      pointer-events: none;
      &:after {
        border-bottom: 1px solid
          ${({ $isDarkMode }) => ($isDarkMode ? darkModeTextColor : "black")};
        width: 100%;
        left: 0%;
      }
    }
  }
  @media print {
    margin: 1em 1em 0 auto;
    &&& {
      position: absolute !important;
    }
  }
`;

/** toggles the isTilesPageFullDay setting and indicates if it's currently active */
const BtnToggleTilesFullDay = () => {
  const { isTilesPageFullDay, setIsTilesPageFullDay, dayStartMsOffset } =
    useSettings();
  const dispatch = useDispatch();
  const formatZoned = useFormatZoned();
  const timeZoneMsOffset = useTimeZoneMsOffset();
  const today = getToday(dayStartMsOffset, timeZoneMsOffset, formatZoned);
  const goToCurrentDay = () =>
    dispatch(
      goToDay({
        newSelectedDay: today,
        dayStartMsOffset,
        timeZoneMsOffset,
        shouldGoToFirstShiftInDay: false,
        shouldGoToCurrentShift: false,
        formatZoned,
      })
    );
  const goToCurrentShift = () =>
    dispatch(
      goToDay({
        newSelectedDay: today,
        dayStartMsOffset,
        timeZoneMsOffset,
        shouldGoToFirstShiftInDay: false,
        shouldGoToCurrentShift: true,
        formatZoned,
      })
    );

  const { translate } = useFlightTranslation();

  const [isDarkMode] = useIsDarkMode();
  return (
    <BtnToggleTilesFullDayStyles
      data-component-name={"Toggle Tiles Full Day"}
      $isDarkMode={isDarkMode}
    >
      <button
        disabled={!isTilesPageFullDay}
        onClick={() => {
          setIsTilesPageFullDay(false);
          goToCurrentShift();
        }}
        className={`btnToggleFullDay${!isTilesPageFullDay ? " active" : ""}`}
      >
        {translate("Shift_view")}
      </button>
      <button
        disabled={isTilesPageFullDay}
        onClick={() => {
          setIsTilesPageFullDay(true);
          goToCurrentDay();
        }}
        className={`btnToggleFullDay${isTilesPageFullDay ? " active" : ""}`}
      >
        {translate(FULL_DAY_TITLE)}
      </button>
    </BtnToggleTilesFullDayStyles>
  );
};

export default BtnToggleTilesFullDay;
